import { Config } from './../models/config';
import { AngularDotcodesService } from './../angular-dotcodes.service';
import { DotCode } from './../models/dotcode.model';
import { Component, OnInit, Input, EventEmitter, Output, Optional, Inject } from '@angular/core';

@Component({
  selector: 'fdot-dotcodes-select',
  template: `<select [(ngModel)]="selectedCode" (change)="codeChanged()" class="form-control" [disabled]="disabled">
  <option *ngIf="useDefaultSelect" value="">
    {{defaultSelectText}}
  </option>
  <option *ngFor="let code of codes" [ngValue]="code">
    {{code.description}}
  </option>
</select>
`,
  styles: [``]
})
export class DotcodesSelectComponent implements OnInit {

  private _value: string;
  codes: DotCode[];

  @Input()
  column: string;

  @Input()
  set value(value) {
    this._value = value;
    this.setSelectedCode();
  }

  get value(): string {
    return this._value;
  }

  @Input()
  disabled?: boolean;

  @Output()
  selectedDotcode = new EventEmitter<DotCode>();
  selectedCode: DotCode;

  @Input()
  useDefaultSelect?: boolean;
  @Input()
  defaultSelectText?: string;

  constructor(private dotCodeService: AngularDotcodesService, @Inject('config') private config: Config) {
  }

  ngOnInit() {

    // tslint:disable-next-line:triple-equals
    if (!(this.useDefaultSelect === false || <any>this.useDefaultSelect === 'false')
      && this.config != null && this.config.useDefaultSelect) {
      this.useDefaultSelect = true;
    } else {
      this.useDefaultSelect = false;
    }
    if (!this.defaultSelectText && this.config != null && this.config.defaultSelectText) {
      this.defaultSelectText = this.config.defaultSelectText;
    }
    this.dotCodeService.GetCodes(this.column).subscribe(codes => {
      this.codes = codes;

      this.setSelectedCode();
    });
  }

  private setSelectedCode() {
    if (!this.codes) {
      return;
    }
    if (this.value) {
      const code = this.codes.find(c => c.value === this.value);

      if (code) {
        this.selectedCode = code;
        this.codeChanged();
      }
    }
  }

  public codeChanged() {
    this.selectedDotcode.emit(this.selectedCode);
  }

}
